module.exports = __webpack_public_path__ + "static/media/ACV.21b24c03.pdf";